import { useEffect, useState } from "react";
import { Mail, Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

// "Xcelio has a new home" email from Adelaida: test to yourself, then send to all once xcelio.app is live.
export default function AdminLaunchEmail() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState("");
  const [confirm, setConfirm] = useState(false);
  const load = () => api.get("/admin/launch-email/status").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const run = async (kind) => {
    setBusy(kind);
    try {
      const { data } = await api.post(`/admin/launch-email/${kind}`);
      toast.success(kind === "test" ? `Test sent to ${data.to}` : "Sending to all members now");
      if (kind === "send") setTimeout(load, 4000);
    } catch (e) { toast.error(e.response?.data?.detail || "Couldn't send"); }
    setBusy("");
  };
  return (
    <section className="rounded-3xl border border-border bg-card/40 p-6 mb-8" data-testid="admin-launch-email">
      <h3 className="font-serif text-xl flex items-center gap-2"><Mail className="w-5 h-5 text-primary" /> Launch email · xcelio.app</h3>
      <p className="text-sm text-muted-foreground mt-1 mb-4">A short note from Adelaida telling every member about Xcelio's new home. Each member gets it once.</p>
      {s && (
        <p className="text-sm mb-5" data-testid="launch-email-status">
          <span className={s.live ? "text-emerald-400" : "text-amber-400"}>{s.live ? "xcelio.app is live" : "xcelio.app isn't live yet"}</span>
          <span className="text-muted-foreground"> · sent to {s.sent} of {s.members} members</span>
        </p>
      )}
      <div className="flex flex-wrap gap-3">
        <Button variant="outline" className="rounded-full" onClick={() => run("test")} disabled={!!busy} data-testid="launch-email-test-btn">
          {busy === "test" ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send test to me"}
        </Button>
        <Button className="rounded-full disabled:opacity-35" onClick={() => setConfirm(true)} disabled={!!busy || !s?.live} data-testid="launch-email-send-btn">
          <Send className="w-4 h-4 mr-2" /> Send to all members
        </Button>
      </div>
      <AlertDialog open={confirm} onOpenChange={setConfirm}>
        <AlertDialogContent data-testid="launch-email-confirm">
          <AlertDialogHeader>
            <AlertDialogTitle>Send to every member?</AlertDialogTitle>
            <AlertDialogDescription>Real emails will go to {s ? s.members - s.sent : "all"} members who haven't had it yet. This can't be undone.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="launch-email-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={() => run("send")} data-testid="launch-email-confirm-btn">Yes, send</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  );
}
